import { InjectionToken } from "@angular/core";
import { SharedConfig } from "../../msal";

export let APP_CONFIG = new InjectionToken<SharedConfig>('APP_CONFIG')